import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { SmartadminLayoutModule } from "./layout";

import { I18nModule } from "./i18n/i18n.module";
import { UtilsModule } from "./utils/utils.module";
import { BootstrapModule } from "@app/shared/bootstrap.module";
import { PipesModule } from "./pipes/pipes.module";
// import { UserModule } from "./user/user.module";
// import {VoiceControlModule} from "./voice-control/voice-control.module";

import { SmartadminWidgetsModule } from "./widgets/smartadmin-widgets.module";

// import {ChatModule} from "./chat/chat.module";
import { StatsModule } from "./stats/stats.module";
import { InlineGraphsModule } from "./graphs/inline/inline-graphs.module";
import { SmartadminFormsLiteModule } from "./forms/smartadmin-forms-lite.module";
import { SmartProgressbarModule } from "./ui/smart-progressbar/smart-progressbar.module";
// import { CalendarComponentsModule } from "@app/shared/calendar/calendar-components.module";
import { OrderModule } from 'ngx-order-pipe';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { Ng5SliderModule } from 'ng5-slider';
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown-angular7";
import { DxDiagramModule, DxPopupModule, DxTemplateModule, DxDataGridModule, DxDropDownBoxModule, DxTreeViewModule, DxTabPanelModule, DxTreeListModule, DxRadioGroupModule, DxTabsModule, DxValidatorModule, DxButtonModule, DxDateBoxModule } from "devextreme-angular";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SmartadminLayoutModule,
    BootstrapModule,
    NgIdleKeepaliveModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    DxDataGridModule,
    DxTreeViewModule,
    DxRadioGroupModule,
    DxTreeViewModule,
    DxTreeListModule,
    DxTabsModule,
    DxButtonModule,
    DxDiagramModule,
    DxPopupModule,
    DxTemplateModule,
    DxDataGridModule,
    DxValidatorModule,
    DxTabPanelModule,
    DxDropDownBoxModule,
  ],
  declarations: [],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    // UserModule,
    SmartadminLayoutModule,
    BootstrapModule,
    I18nModule,
    UtilsModule,
    PipesModule,
    SmartadminFormsLiteModule,
    SmartProgressbarModule,
    InlineGraphsModule,
    SmartadminWidgetsModule,
    // ChatModule,
    StatsModule,
    // VoiceControlModule,
    // CalendarComponentsModule,
    OrderModule,
    FilterPipeModule,
    Ng5SliderModule,
    NgMultiSelectDropDownModule,
    DxDataGridModule,
    DxTreeViewModule,
    DxRadioGroupModule,
    DxTreeViewModule,
    DxTreeListModule,
    DxTabsModule,
    DxButtonModule,
    DxDiagramModule,
    DxPopupModule,
    DxTemplateModule,
    DxDataGridModule,
    DxValidatorModule,
    DxTabPanelModule,
    DxDropDownBoxModule,
  ]
})
export class SharedModule { }
